import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DropdownList } from 'react-widgets';
import { normalize, schema } from 'normalizr';
import { loadMakeupSummaryByChildAndTerm } from './actions';
import { loadEnrolmentsForChild } from '../enrolments/actions';
import { getDefaultActiveTerm, getLastTerm } from '../terms/actions';
import CollapsablePanel from '../../common/components/CollapsablePanel';
import ui from '../../common/services/ui';
import EntitiesList from '../../common/components/EntitiesList';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import { faCalendarDays } from '@fortawesome/free-regular-svg-icons';
import { Panel } from 'react-bootstrap';

class ParentMakeupSummary extends Component {
	constructor(props) {
		super(props);
		this.handleChildSelect = this.handleChildSelect.bind(this);

		const { children } = this.props.parent;
		const firstChild = children && children[0];
		this.state = {
			selectedChildId: firstChild && firstChild.id
		};
	}

	componentDidMount() {
		this.loadData();
	}

	columns(t) {
		const columns = [
			{
				header: t('MakeupSummary_LessonDate'),
				accessor: 'lessonDate',
				cell: (lessonDate) => (ui.formatDate(lessonDate)),
			},
			{
				header: t('MakeupSummary_WeeklyProgram'),
				accessor: 'weeklyProgramItem',
				cell: (weeklyProgramItem) => weeklyProgramItem.name,
			},
			{
				accessor: 'canceled',
				cell: (canceled, row) => canceled && row.canceledByAdmin ? t('MakeupSummary_CanceledByAdminOn', { cancellationDate: ui.formatDateTime(row.cancellationDate) }) :
					(canceled && !row.canceledByAdmin ? t('MakeupSummary_CanceledByParentOn', { cancellationDate: ui.formatDateTime(row.cancellationDate) }) : '')
			},
			{
				accessor: 'isAttended',
				cell: (isAttended) => isAttended ? t('MakeupSummary_Attended') : ''
			}
		];

		return columns;
	}

	loadData() {
		if (this.state.selectedChildId) {

			const onSuccess = () => {
				const terms = this.getTermsByChild();
				if (terms.activeTerm) {
					this.loadMakeupSummaryByTerm(terms.activeTerm.id)
				}
			}
			this.props.loadEnrolmentsForChild(this.state.selectedChildId, onSuccess);
		}
	}

	handleChildSelect(value) {
		this.setState({ selectedChildId: value.id }, () => this.loadData());
	}

	normalizeData(enrolmentsByChild) {
		const term = new schema.Entity('terms', {}, {
			idAttribute: c => c.id
		});
		const enrolment = new schema.Entity('enrolments', { term: term }, {
			idAttribute: p => p.id
		});
		const normalizedData = normalize(enrolmentsByChild, [enrolment]);
		return normalizedData;
	}

	getTermsByChild() {
		const { enrolmentsByChildFilter, enrolments } = this.props;
		const normalizedData = this.normalizeData((enrolmentsByChildFilter[this.state.selectedChildId] || { ids: [] }).ids.map(id => enrolments[id]));
		const terms = normalizedData && normalizedData.entities && normalizedData.entities.terms;

		let activeTerm = terms && getDefaultActiveTerm(terms);
		if (!activeTerm && terms) {
			activeTerm = getLastTerm(terms);
		}
		return {
			terms,
			activeTerm
		}
	}

	loadMakeupSummaryByTerm(termId) {
		this.props.loadMakeupSummaryByChildAndTerm(this.state.selectedChildId, termId);
	}

	renderTermLessons(termId) {
		const { makeupSummary, makeupSummaryByChildAndTermFilter, t } = this.props;

		const makeupSummaryFilter = makeupSummaryByChildAndTermFilter[`${this.state.selectedChildId}-${termId}`] || { ids: [] };
		const termLessons = makeupSummaryFilter.ids.map(id => makeupSummary[id])

		const allowedMakeup = termLessons.filter(l => l.allowedMakeup).sort((a, b) => moment(a.start) - moment(b.start));
		const makeups = termLessons.filter(l => l.lessonType === 3).sort((a, b) => moment(a.start) - moment(b.start));

		return <div>
			<h4>{t('MakeupSummary_AllowedMakeup')}</h4>
			<EntitiesList columns={this.columns(t)} data={allowedMakeup} />
			<h4>{t('MakeupSummary_Makeups')}</h4>
			<EntitiesList columns={this.columns(t)} data={makeups} />
		</div>
	}

	render() {
		const { parent, t } = this.props;

		if (!parent.children || parent.children.length === 0) {
			return <Panel><Panel.Body>{t('List_Empty')}</Panel.Body></Panel>;
		}

		const terms = this.getTermsByChild();

		return <React.Fragment>
			{parent.children.length > 1 ?
				<DropdownList data={parent.children} style={{ marginBottom: '10px' }} defaultValue={parent.children[0]} textField='fullName' valueField='id' onChange={this.handleChildSelect} /> :
				<h4>{parent.children[0].fullName}</h4>}
			{terms.terms ? Object.values(terms.terms).sort((a, b) => moment(b.startDate) - moment(a.startDate)).map(t =>
				<CollapsablePanel key={t.id} icon={faCalendarDays} title={t.name} collapsed={terms.activeTerm && t.id != terms.activeTerm.id} onExpand={() => this.loadMakeupSummaryByTerm(t.id)}>
					{this.renderTermLessons(t.id)}
				</CollapsablePanel>) : <Panel><Panel.Body>{t('List_Empty')}</Panel.Body></Panel>}
		</React.Fragment>;
	}
}

const mapStateToProps = (state, ownProps) => {

	const {
		entities: { enrolments, makeupSummary },
		filters: { enrolmentsByChild, makeupSummaryByChildAndTerm }
	} = state;

	return {
		enrolments,
		makeupSummary,
		parent: ownProps.parent,
		enrolmentsByChildFilter: enrolmentsByChild,
		makeupSummaryByChildAndTermFilter: makeupSummaryByChildAndTerm
	};
};

export default connect(mapStateToProps, {
	loadEnrolmentsForChild,
	loadMakeupSummaryByChildAndTerm
})(withTranslation()(ParentMakeupSummary));